import { qportalApi } from './qportal-api';
import { accountActionApi } from './account-action-api';
const login = (credentials) => {
    return qportalApi.post('account/authenticate', credentials);
};
const getRefreshToken = (refreshToken) => {
    return qportalApi.post('token/refresh', refreshToken);
};
const verifyToken = (refreshToken) => {
    return accountActionApi.post('token/verify-token', refreshToken);
};
const signUp = (user) => {
    return qportalApi.post('account/register', user);
};
const confirmEmail = (confirmation) => {
    return accountActionApi.post('account/email-confirmation', confirmation);
};
const regenerateEmailLink = (userId) => {
    return accountActionApi.put(`account/regenerateEmailLink/${encodeURIComponent(userId)}`);
};
const forgotPassword = (input) => {
    return accountActionApi.post('account/forgot-password', input);
};
const resetPassword = (input) => {
    return accountActionApi.post('account/reset-password', input);
};
const checkShuftiProStatus = () => {
    return qportalApi.get('users/checkShuftiProStatus');
};
const AuthApi = {
    login,
    getRefreshToken,
    signUp,
    confirmEmail,
    forgotPassword,
    resetPassword,
    verifyToken,
    checkShuftiProStatus,
    regenerateEmailLink
};
export default AuthApi;
